<template>
  <div>
    <by-product
      v-if="selectedType === 'product'"
      :payload="payload"
      :sumPayload="sumPayload"
    />
    <by-order
      v-else-if="selectedType === 'order'"
      :payload="payload"
      :sumPayload="sumPayload"
    />
    <by-location
      v-else-if="selectedType === 'location'"
      :payload="payload"
      :sumPayload="sumPayload"
    />
    <by-day
      v-else-if="selectedType === 'day'"
      :payload="payload"
      :sumPayload="sumPayload"
    />
    <by-lot
      v-else-if="selectedType === 'lot'"
      :payload="payload"
      :sumPayload="sumPayload"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ByProduct from './List/byProduct.vue'
import ByOrder from './List/byOrder.vue'
import ByLocation from './List/byLocation.vue'
import ByDay from './List/byDay.vue'
import ByLot from './List/byLot.vue'

export default defineComponent({
  components: {
    ByProduct,
    ByOrder,
    ByLocation,
    ByDay,
    ByLot,
  },
  props: {
    iscomponentactive: {
      type: Boolean,
      required: false,
    },
    selectedCallback: {
      type: Function,
      required: true,
    },
    clearComponent: {
      type: Function,
      required: true,
    },
    payload: {
      type: Array,
      required: false,
    },
    sumPayload: {
      type: Object,
      required: false,
    },
    selectedType: {
      type: String,
      required: false,
    },
  },
})
</script>
